import { render, staticRenderFns } from "./NumberInput.html?vue&type=template&id=86c97a0a&scoped=true&"
import script from "./NumberInput.js?vue&type=script&lang=js&"
export * from "./NumberInput.js?vue&type=script&lang=js&"
import style0 from "./NumberInput.scss?vue&type=style&index=0&id=86c97a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c97a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
